import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import Loader from "../components/loader";
import { Auth } from "../layout/Authentication";
import Private from "../layout/PrivateRoutes";
import PatientRoutes from "../layout/Patient";
import DoctorRoutes from "../layout/Doctor";
import Public from "../layout/PublicRoutes";
import GuestRoutes from "../layout/GuestRoutes";
import PublicFooter from "../layout/PublicFooterRotutes";
import UserAlreadyExistsModal from "../components/UserAlreadyExistsModal";
const LazyNotificationPage = lazy(() => import("../pages/NotificationPage"));
const LazyLogin = lazy(() => import("../pages/Login"));
const LazySignup = lazy(() => import("../pages/Signup"));
const LazyPatientDashboard = lazy(() => import("../pages/PatientDashboard"));
const LazyResetPassword = lazy(() => import("../pages/ResetPassword"));
const LazyPasswordOTP = lazy(() => import("../pages/PasswordOTP"));
const LazyMyOrder = lazy(() => import("../pages/MyOrder"));
const LazyResources = lazy(() => import("../pages/Resources"));
const LazyCustomerSupport = lazy(() => import("../pages/CustomerSupport"));
const LazyCustomerSupportDetails = lazy(
  () => import("../pages/CustomerSupportDetails"),
);
const LazyContact = lazy(() => import("../pages/Contact"));
const LazyFAQ = lazy(() => import("../pages/FAQ"));
const LazyCheckout = lazy(() => import("../pages/Checkout"));
const LazyCreatePassword = lazy(() => import("../pages/CreatePassword"));
const LazyDentistPortal = lazy(() => import("../pages/DentistPortal"));
const LazyMyProfile = lazy(() => import("../pages/MyProfile"));
const LazyMyScans = lazy(() => import("../pages/MyScans"));
const LazyConnected = lazy(() => import("../pages/Connected"));
const LazyMySubscription = lazy(() => import("../pages/MySubscription"));
const LazyPersonalDetailsSSO = lazy(
  () => import("../pages/PersonalDetailsSSO"),
);
const LazyQuickStartGuide = lazy(() => import("../pages/QuickStartGuide"));
const LazyTechnicalResourceVideos = lazy(
  () => import("../pages/TechnicalResourcesVideos"),
);
const LazyPaymentSuccess = lazy(() => import("../pages/PaymentSuccess"));
const LazyGrindGuard = lazy(() => import("../pages/GrindGuard"));
const LazyDoctorCheckout = lazy(() => import("../pages/DoctorCheckout"));
const LazyPrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const LazyTermofUse = lazy(() => import("../pages/TermOfUse"));
const LazyAbouPrivacyPolicy = lazy(
  () => import("../pages/Patient_PrivacyPolicy"),
);
const LazyAboutTermofservice = lazy(
  () => import("../pages/Patient_Terms_of_Service"),
);
const LazyAboutTermofPurchase = lazy(
  () => import("../pages/Patient_Terms_of_Purchase"),
);
const LazyHIPPA = lazy(() => import("../pages/Patient_HIPPA"));
const LazyForceLogin = lazy(() => import("../pages/ForceLogin"));
const LazyDeleteAccountRequest = lazy(
  () => import("../pages/DeleteAccountRequest"),
);
const LazyGuestLogin = lazy(() => import("../pages/GuestLogin"));
const LazyMobileCheckout = lazy(() => import("../pages/MobileCheckout"));
const LazySelectProduct = lazy(() => import("../pages/SelectProduct"));
const LazyGuestCheckout = lazy(() => import("../pages/GuestCheckout"));

export default function AllRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <Routes>
          <Route element={<Auth />}>
            <Route path="/" element={<LazyLogin />} />
            <Route path="/signup" element={<LazySignup />} />
            <Route path="/reset_password" element={<LazyResetPassword />} />
            <Route path="/password_otp" element={<LazyPasswordOTP />} />
            <Route path="/create_password" element={<LazyCreatePassword />} />
            <Route
              path="/personal_details"
              element={<LazyPersonalDetailsSSO />}
            />
            <Route path="/guest_login" element={<LazyGuestLogin />} />
          </Route>
          <Route element={<PatientRoutes />}>
            <Route
              path="/patient_dashboard"
              element={<LazyPatientDashboard />}
            />
            <Route path="/resources" element={<LazyResources />} />
            <Route path="/connected" element={<LazyConnected />} />
            <Route path="/my_scans" element={<LazyMyScans />} />
            <Route path="/my_subscription" element={<LazyMySubscription />} />
          </Route>
          <Route element={<DoctorRoutes />}>
            <Route path="/dentist_portal" element={<LazyDentistPortal />} />
            <Route path="/grind_guard" element={<LazyGrindGuard />} />
            <Route path="/doctor_checkout" element={<LazyDoctorCheckout />} />
          </Route>
          <Route element={<Private role="all" />}>
            <Route
              path="/notification_page"
              element={<LazyNotificationPage />}
            />
            <Route path="/my_order" element={<LazyMyOrder />} />
            <Route path="/customer_support" element={<LazyCustomerSupport />} />
            <Route
              path="/customer_support_details"
              element={<LazyCustomerSupportDetails />}
            />
            <Route
              path="/quick_start_guide"
              element={<LazyQuickStartGuide />}
            />
            <Route
              path="/technical_resourcevideos"
              element={<LazyTechnicalResourceVideos />}
            />
            <Route path="/contact" element={<LazyContact />} />
            <Route path="/faq" element={<LazyFAQ />} />
            <Route path="/checkout" element={<LazyCheckout />} />
            <Route path="/my_profile" element={<LazyMyProfile />} />
            <Route path="/PaymentSuccess" element={<LazyPaymentSuccess />} />
            <Route path="/select_product" element={<LazySelectProduct />} />
          </Route>

          <Route element={<GuestRoutes />}>
            <Route path="/checkout" element={<LazyCheckout />} />
          </Route>
          <Route element={<PublicFooter />}>
            <Route path="/guest-checkout" element={<LazyGuestCheckout />} />
          </Route>

          <Route element={<Public />}>
            <Route path="/privacy_policy" element={<LazyPrivacyPolicy />} />
            <Route path="/term_of_use" element={<LazyTermofUse />} />
            <Route
              path="/about/privacy_policy"
              element={<LazyAbouPrivacyPolicy />}
            />
            <Route
              path="/about/term_of_service"
              element={<LazyAboutTermofservice />}
            />
            <Route
              path="/about/term_of_purchase"
              element={<LazyAboutTermofPurchase />}
            />
            <Route path="/HIPPA" element={<LazyHIPPA />} />
          </Route>

          <Route
            path="/delete-account-request"
            element={<LazyDeleteAccountRequest />}
          />
          <Route path="/force-login" element={<LazyForceLogin />} />
          <Route path="/mobile-checkout" element={<LazyMobileCheckout />} />
        </Routes>
      </Router>
    </Suspense>
  );
}
